// removed by extract-text-webpack-plugin
module.exports = {"text_area":"styles__text_area___LDZDp","focus_error":"styles__focus_error___2RUxr","limit":"styles__limit___hLgPo"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/Inputs/TextArea/styles.css
// module id = 3203
// module chunks = 0